import configProvider from "../config/configProvider";

export const apiScopes = [configProvider.API_AD_SCOPE];
